import { createKeySelector, createDynamicKeySelector } from 'state/common/selectorFactories';

import { EMPTY_OBJECT } from 'config/constants';

import type { Episode } from 'types/shows';

export const getEpisodeData = (state: any) => state.episodes || EMPTY_OBJECT;
export const getEpisodeMap = createKeySelector(getEpisodeData, 'byId', EMPTY_OBJECT);
export const getEpisodeById = createDynamicKeySelector<Episode | undefined | null, string>(getEpisodeMap, null);
